import React, { Fragment } from 'react';
import { ProgramList } from './ProgramList';
import { Container, Content, TitleContainer } from './ShowBroadcastPage.styles';
import { useBottomDialogDispatch } from '../../components/BottomDialog/BottomDialogContext';
import { useLoadingBar } from '../../components/LoadingBar/LoadingBarProvider';
import { ErrorIfEmpty } from '../../components/Message/ErrorIfEmpty';
import { DetailContent } from '../../components/TvGuide/Detail/DetailContent';
import { ShowTitle } from '../Show/ShowInfo/ShowTitle';
import { useShowDetails } from '../Show/use-show-details';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowBroadcastPage = ({
  initialData
}) => {
  const {
    show,
    isLoading: showLoading
  } = useShowDetails(initialData);
  useLoadingBar(showLoading);
  const dispatch = useBottomDialogDispatch();
  const topicUrn = show && show.topicUrns.length > 0 ? show?.topicUrns[0] : undefined;
  const onSelectProgram = selectedProgram => {
    dispatch({
      type: 'show-dialog',
      dialog: /*#__PURE__*/_jsx(DetailContent, {
        analyticsPageId: 'showBroadcasts',
        selectedProgram: selectedProgram,
        onClose: () => dispatch({
          type: 'remove-dialog'
        })
      })
    });
  };
  return /*#__PURE__*/_jsx(Fragment, {
    children: show && /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        topicUrn: topicUrn,
        children: [/*#__PURE__*/_jsx(TitleContainer, {
          children: /*#__PURE__*/_jsx(ShowTitle, {
            show: show
          })
        }), /*#__PURE__*/_jsx(Content, {
          children: /*#__PURE__*/_jsx(ErrorIfEmpty, {
            isLoading: showLoading,
            children: /*#__PURE__*/_jsx(ProgramList, {
              show: show,
              onSelect: onSelectProgram
            })
          })
        })]
      })
    })
  });
};